export const DefaultDIDListenList = [
    'caAccountRegister',
    'caAccountRecover',
    'onScanLoginSuccess',
    'onScanLogin',
];
